import React, {Component, ReactElement} from 'react'
import NatStepComponent, {DIspStepInfo, Step} from '../common/resident/NatStepComponent'
import {
    ContentsSubTitleInner,
    ContentsSubTitleWrapper,
    ParagraphText,
    TxtBold,
    WideMainContainer,
} from '../../../styledComponents/ContentsArea'
import {StyledP} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {Box} from '@mui/material'
import {CenterPlainLinkStyledButton} from '../../../styledComponents/Button'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {BlockSpacer} from '../../../styledComponents/ResponsiveConvenience'
import {ListGridContainer} from '../applications/common/resident/NatResidentApplicationsCommon'
import {Location} from 'react-router-dom'

interface Props {
    location: Location
}

interface States {
    dIspStepInfo: DIspStepInfo
}

class NatResidentPasswordResetMailAddressCompletePage extends Component<Props & ResidentPagePropsSet, States> {
    constructor(props: Props & ResidentPagePropsSet) {
        super(props)
        this.state = {
            dIspStepInfo: {mailAddressInput: true, mailSend: true},
        }

        this.backLoginButtonClick = this.backLoginButtonClick.bind(this)
    }

    // ログインページへ
    backLoginButtonClick(): void {
        this.props.navigate(
            `/resident/login`,
        )
    };

    render(): ReactElement {
        return (
            <>
                <NatStepComponent
                    dIspStepInfo={this.state.dIspStepInfo}
                    nowStep={Step.MAIL_SEND}
                />
                <ContentsSubTitleWrapper>
                    <ContentsSubTitleInner>
                        メールアドレス入力
                    </ContentsSubTitleInner>
                </ContentsSubTitleWrapper>
                <WideMainContainer>
                    <BlockSpacer height={'15px'}/>
                    <TxtBold>確認メールの送信が完了しました。</TxtBold>
                    <BlockSpacer height={'15px'}/>
                    {this.props.location.state && this.props.location.state.mailAddress &&
                        <Box>
                            <ParagraphText>以下の宛先にメールが送信されている事をご確認ください。</ParagraphText>
                            <TextMailAddress>{this.props.location.state.mailAddress}</TextMailAddress>
                        </Box>
                    }
                    <span>注意事項</span>
                    <ListGridContainer>
                        <div>・</div>
                        <div>メールが届かない場合は、ご契約のプロバイダやメールソフトの設定などにより、受信ができない可能性がございます。</div>
                        <div>・</div>
                        <div>迷惑メールの設定・ドメイン指定受信をご確認ください。</div>
                    </ListGridContainer>
                    <BlockSpacer height={'20px'}/>
                </WideMainContainer>
                <Box height={'30px'}/>
                <CenterPlainLinkStyledButton onClick={this.backLoginButtonClick}>
                    ログイン画面へ戻る
                </CenterPlainLinkStyledButton>
                <Box height={'30px'}/>
            </>
        )
    }
}

export default createResidentPage(NatResidentPasswordResetMailAddressCompletePage)

// メールアドレス
export const TextMailAddress: StyledP = styled.p`
  text-align: center;
`
